import React from "react";

const AdminTags = (props) => {
  return <div> this will be tags admin</div>;
};

export default AdminTags;
